import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { cancel_feedback_path } from '@routes';
import { ClickTarget, Page, click } from '@tracking';

const CANCEL_ACCOUNT_TEXT = 'cancel your account';

const CancelAccount = () => {
  const { trackEvent } = useEventTracking({
    page: Page.UpdatePage,
  });

  const handleCancelAccount = () => {
    trackEvent(click({ clickTarget: ClickTarget.Cancel, clickText: CANCEL_ACCOUNT_TEXT }));
  };

  return (
    <div className="m-auto w-full max-w-[624px]">
      <p className="cancel">
        If you no longer wish to subscribe to The Information, you can{' '}
        <a
          className="cancel-account"
          href={cancel_feedback_path()}
          onClickCapture={handleCancelAccount}
        >
          {CANCEL_ACCOUNT_TEXT}
        </a>
        .
      </p>
    </div>
  );
};

export default CancelAccount;
